/* global axios */
import ApiClient from './ApiClient';

// Sante-CRM: cards do funil de vendas (pacientes no Kanban)
class PipelineItemsAPI extends ApiClient {
  constructor() {
    super('pipeline_items', { accountScoped: true });
  }

  get({ pipelineId, pipelineStageId, conversationId, contactId } = {}) {
    return axios.get(this.url, {
      params: {
        pipeline_id: pipelineId,
        pipeline_stage_id: pipelineStageId,
        conversation_id: conversationId,
        contact_id: contactId,
      },
    });
  }

  create(itemAttributes) {
    return axios.post(this.url, { pipeline_item: itemAttributes });
  }

  update(id, itemAttributes) {
    return axios.patch(`${this.url}/${id}`, { pipeline_item: itemAttributes });
  }
}

export default new PipelineItemsAPI();
